import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'excludedKey',
    standalone: false,
})
export class ExcludedKeyPipe implements PipeTransform {
    transform(user_id: any, date: Date): string {
        return `${user_id}-${formatDate(date, 'yyyy-MM-dd', 'nl')}`;
    }
}
